import React from 'react'
import Button from '../../../Components/commonButton/commonButton'
import TextField from '../../../Components/textField/textField'
import TimeTextField from '../../../Components/timeTextField/TimeTextField'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import { setCheckValue } from "../../../services/Functions";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class AddReasonView extends React.Component {

  state = {
    show: false,
    reason: "",
    id: null,
    message: "",
    reload: false,
    andon: false,
    code: "",
    ftq_count: false,
    planned_time: false,
    planned_stop: false,
    all_days: false,
    duration: "",
    block_machine: false,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  }

  sendData = () => {
    const { reason, andon, planned_time, code, duration, ftq_count, planned_stop, block_machine, all_days } = this.state
    if ((reason !== "" && reason !== null) && (code !== "" && code !== null) && ((this.state.planned_stop == true && (this.state.planned_time != "00:00:00" && this.state.planned_time != "" && this.state.planned_time != null)) || this.state.planned_stop == false)) {
      const nowDateTime = new Date().toISOString()
      const nowDate = nowDateTime.split('T')[0]
      const targetDuration = new Date(nowDate + duration)
      Api.post('/reasons-stop/', {
        description: reason,
        code: code,
        tracking: andon,
        ftq_count: ftq_count,
        planned_time: planned_time,
        planned_stop: planned_stop,
        block_machine: block_machine,
        all_days: all_days
      }).then(() => {
        this.setState({notification: true, notification_message: "Motivo cadastrado com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
      }).catch(err => {
        if (err.response.status === 400)
          return this.setState({ message: "" + err.response.data.message, show: true })
      })
    } else {
      return this.setState({ message: "Necessário preencher todos os campos.", show: true })
    }
  }

  callbackfunction = () => { this.setState({ show: false }) }
  callBackReason = (child) => { this.setState({ reason: child }) }
  callBackCode = (value) => { this.setState({ code: value }) }
  stopTimeCallback = (value) => { this.setState({ planned_time: value }) }

  render() {
    let { show, message, reload, planned_stop, notification, notification_message, notification_type} = this.state
    return (
      <div className='box'>
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} reload={reload} /> : null}
        <form className="input_fields_add_reason form">
          <h4>Adicionar Motivo</h4>
          <div className='inputs'>
            <div className='tf1AddReason element'><TextField section={true} focus={true} title="Código" max={4} parentCallback={this.callBackCode} value={this.state.code} validationType="int"/></div>
            <div className='tf2AddReason element'>
              <TextField title="Descrição" max={45} parentCallback={this.callBackReason} value={this.state.reason} validationType="varchar"/></div>
            <div className="checkboxs">
              <div className="form-check element">
                <input className="form-check-input" type="checkbox" value={this.state.planned_stop}
                  name="planned_stop"
                  onClick={(v) => setCheckValue(v, e => { this.setState({ planned_stop: e },()=>{
                    document.getElementById("time-texfield").focus()
                  }) })}
                id="flexCheckDefault"/>
                  <label className="form-check-label" for="Parada programada">
                  Parada programada
                  </label>
              </div>
              <div className="form-check element">
                <input className="form-check-input" type="checkbox" value={this.state.block_machine}  
                name="block_machine"
                onClick={(v) => setCheckValue(v, e => { this.setState({ block_machine: e }) })}
                id="flexCheckDefault"/>
                  <label className="form-check-label" for="block_machine">
                    Bloquear Máquina
                  </label>
              </div>
              <div className="form-check element">
                <input className="form-check-input" type="checkbox" value={this.state.andon} 
                  name="andon"
                  onClick={(v) => setCheckValue(v, e => { this.setState({andon: e }) })}
                  id="flexCheckDefault"/>
                  <label className="form-check-label" for="andon">
                    Andon
                  </label>
              </div>
              <div className="form-check element">
                <input className="form-check-input" type="checkbox" value={this.state.ftq_count}
                  name="ftq_count"
                  onClick={(v) => setCheckValue(v, e => { this.setState({ ftq_count: e }) })}
                  id="flexCheckDefault"/>
                  <label className="form-check-label" for="ftq">
                    Setup/FTQ   
                  </label>
              </div>
            </div>
            <div className='tf3AddReason element' name="duration" style={{display:planned_stop?"block":"none"}} >
              <TimeTextField id={"time-texfield"} 
                          title="Tempo de parada" 
                          hideInput={false}
                          parentCallback={this.stopTimeCallback} 
                          seconds={true} disabled={false} 
              />
            </div>
            <div className="form-check element" style={{display:planned_stop?"block":"none"}}>
                <input className="form-check-input" type="checkbox" value={this.state.all_days}
                  name="all_days"
                  onClick={(v) => setCheckValue(v, e => { this.setState({ all_days: e }) })}
                  id="flexCheckDefault"/>
                  <label className="form-check-label" for="all_days">
                    Ocorre em todos os dias, em todos os turnos.   
                  </label>
              </div>
          </div>
          <div className="btnAddReason submitButton"><Button title="Enviar" type parentCallback={this.sendData} /></div>
        </form>
      </div>
    );
  }
}